import classNames from 'classnames';

import React from 'react';

import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';

import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Button, { ButtonProps } from '@mui/material/Button';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  submitBtn: { margin: theme.spacing(2, 0, 0, 0) },
  rightIcon: { marginLeft: theme.spacing(1) },
  leftIcon: { marginRight: theme.spacing(1) },
  buttonDanger: {
    backgroundColor: '#F92949',
    color: '#fff',
    '&:hover': { backgroundColor: '#e80729' },
  },
}));

interface IProps extends ButtonProps {
  isSubmitting?: boolean;
  label?: string;
  submittingLabel?: string;
  icon?: React.ReactNode;
  useButtonDanger?: boolean;
  iconPosition?: 'left' | 'right';
}

export default function ButtonSubmit(props: IProps) {
  const {
    isSubmitting,
    label,
    onClick,
    children,
    className,
    useButtonDanger,
    fullWidth,
    variant,
    color,
    icon: muiIcon,
    disabled,
    size,
    iconPosition,
    disableElevation,
    submittingLabel,
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Button
      disableElevation={disableElevation}
      className={classNames(className, {
        [classes.buttonDanger]: useButtonDanger,
      })}
      size={size}
      disabled={disabled}
      fullWidth={fullWidth}
      variant={variant}
      color={color}
      onClick={isSubmitting ? undefined : onClick}
    >
      {isSubmitting ? (
        <>
          {iconPosition === 'left' && (
            <CircularProgress
              className={classes.leftIcon}
              size={21}
              color="inherit"
            />
          )}
          {submittingLabel || t('processing')}
          {iconPosition !== 'left' && (
            <CircularProgress
              className={classes.rightIcon}
              size={21}
              color="inherit"
            />
          )}
        </>
      ) : (
        <>
          {children || (
            <>
              {iconPosition === 'left' && (
                <Box
                  display="flex"
                  component="span"
                  className={classes.leftIcon}
                >
                  {muiIcon}
                </Box>
              )}
              {label}
              {iconPosition !== 'left' && (
                <Box
                  display="flex"
                  component="span"
                  className={classes.rightIcon}
                >
                  {muiIcon}
                </Box>
              )}
            </>
          )}
        </>
      )}
    </Button>
  );
}
